import React from "react";
import {
  ListItem,
  ListItemText,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import {
  Visibility,
  VisibilityOff,
  Edit,
  Info,
  SettingsRemote,
} from "@material-ui/icons";
import { observer } from "mobx-react";
import { StoreContext } from "../../store/StoreContext";

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
  item: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  arrow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

export const CarItem = observer(({ car }) => {
  const classes = useStyles();
  const {
    addToShowCars,
    removeFromShowCars,
    showCars,
    modalStore: { setEditingCarID, setCommandShowing, setCarInfo },
  } = React.useContext(StoreContext);
  const [showMarker, setShowMarker] = React.useState(true);

  React.useEffect(() => {
    setShowMarker(!!showCars.find((c) => c.id == car.id));
  }, [showCars]);

  const onClick = () => {
    if (showMarker) removeFromShowCars(car.id);
    else addToShowCars(car.id);
    setShowMarker((prev) => !prev);
  };

  const onEditClick = () => {
    setEditingCarID(car.id);
  };

  const infoClick = () => {
    setCarInfo(car.id);
  };

  const commandClick = () => {
    setCommandShowing(true);
  };

  return (
    <div className={classes.nested}>
      <div className={classes.item}>
        <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
          <ListItemText
            primary={car.number}
            primaryTypographyProps={{ style: { fontSize: 12 } }}
          />
          <IconButton size="small" onClick={infoClick}>
            <Info style={{ fontSize: 16 }} />
          </IconButton>
          <IconButton size="small" onClick={commandClick}>
            <SettingsRemote style={{ fontSize: 16 }} />
          </IconButton>
          <IconButton size="small" onClick={onEditClick}>
            <Edit style={{ fontSize: 16 }} />
          </IconButton>
          <IconButton onClick={onClick} className={classes.arrow} size="small">
            {showMarker ? (
              <Visibility htmlColor="green" />
            ) : (
              <VisibilityOff htmlColor="blue" />
            )}
          </IconButton>
        </ListItem>
      </div>
    </div>
  );
});
